export const SET_EXCEPTION_CONFIGURATION_LIST_DATA = 'SET_EXCEPTION_CONFIGURATION_LIST_DATA';
export const OPEN_EXCEPTION_CONFIGURATION_FORM_MODAL = 'OPEN_EXCEPTION_CONFIGURATION_FORM_MODAL';
export const CLOSE_EXCEPTION_CONFIGURATION_FORM_MODAL = 'CLOSE_EXCEPTION_CONFIGURATION_FORM_MODAL';